<template>
  <div id="caijixiangqingLessNew">
    <van-sticky>
      <van-nav-bar :title="title"
                   left-text="返回"
                   left-arrow
                   @click-left="onClickLeft" />
    </van-sticky>
    <!-- 返回顶部 -->
    <div class="toTopIcon" v-if="btnFlag">
        <van-icon name="upgrade" @click.stop="backTop" class="go-top" />
    </div>

    <div class="xinxi">
      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="4.5" class="twoTitle">
            任务名称：
          </van-col>
          <van-col span="19" class="twoLine">
            {{ taskName }}
          </van-col>
        </van-row>
      </div>
      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="4.5" class="twoTitle">
            期&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：
          </van-col>
          <van-col span="7" class="twoLine">
            {{ exeno }}
          </van-col>
          <van-col span="4.5" class="twoTitle">
            截止时间：
          </van-col>
          <van-col span="8" class="twoLine" style="color: red;white-space: nowrap;">
            {{ priceDate }} {{ lateReportTime }}
          </van-col>
        </van-row>
      </div>
      <div>
        <van-row>
          <van-col span="5.5" class="twoTitle">
              监测点筛选：
          </van-col>
          <van-col span="18" class="twoLine" >
            <van-search v-model="dropdownInput"  @focus="hideTabs" @input="fuzzyQuery" placeholder="请输入监测点名称" />
            <div class="wrapper" v-if="showDrop" @click="showTabs">
              <van-list
                class="block"
                v-model="loading1"
                :finished="finished"
                finished-text=""
                @load="onLoad"
              >
                <van-cell v-for="(item,index) in inputTable" :key="index" :title="item.text"
                @click.stop="dropClick(item.value, item.text)" />
              </van-list>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>

    <!-- 商品表格 -->
    <comList
      ref="listRef"
      :list="list"
      :stationList="stationList"
      :lastStation="lastStation"
      @handItemCLick="clickStoreName"
      :saveState="dis"
      :taskConfig="taskConfig"
    ></comList>


    <!-- 按钮 -->
    <div class="bottom">
      <div style="display:flex;box-shadow: 0px -1px 10px #0000004d;height: 100%;align-items: center;">
        <div :class="{ bianhui: dis }" offset="1" style="text-align: center;flex: 1;position: relative;">
          <v-button class="btn1" @click="tongguo">提交</v-button>
        </div>
        <div :class="{ bianhui: dis }" offset="1" style="text-align: center;flex: 1;position: relative;">
          <v-button class="btn1" @click="save">保存</v-button>
        </div>
        <div :class="{ bianhui: cxState}" offset="1" style="text-align: center;flex: 1; position: relative;">
          <v-button class="btn1" @click="chexiao">撤回</v-button>
        </div>
        <div  offset="1" style="text-align: center;flex: 1;position: relative;">
          <v-button class="btn1 btn2" @click="chaKanRiZhi">查看日志</v-button>
        </div>
      </div>
    </div>


     <!-- 商品详细信息弹窗 -->
    <detailDialog
      ref="detailRef"
      :saveState="dis"
      :isGoodsName="isGoodsName"
      @saveBasic="saveBasic"
      :taskConfig="taskConfig"
      :levelNum="levelNum"
      function="xm"
     ></detailDialog>

    <!-- 查看日志弹窗 -->
    <logDialog
      ref="logRef"
      :logList="logList"
     ></logDialog>
  </div>
</template>
<script>
import { loading } from '@/common/loading'
import { saveRow, upOkCountry, getDateRecord,checkLogin,getStationList,dataGridNew, countyRedo } from '@/api/baseMsg'
import { Toast } from 'vant'
import { getName } from '@/utils/getStateName.js';
import detailDialog from "@/components/detailDialog";
import logDialog from "@/components/logDialog";
import comList from "@/components/comList/lessIndex.vue";
import rulesInfoDeal from '@/utils/dataRules.js';
import validRange from "@/utils/validRange.js";
// import { Dialog } from 'vant'
export default {
  name: 'caijixiangqingLessNew',
  components: {
    detailDialog,
    logDialog,
    comList
  },
  data() {
    return {
      title: '小麦监测详情',
      isLoading: false,
      list: [],
      loading: false,
      loading1: false,
      finished: false,
      taskCode: this.$route.query.taskCode,
      exeno: this.$route.query.exeno,
      taskID: this.$route.query.taskId,
      // shopId: this.$route.query.shopId,
      shispflag: this.$route.query.shispflag, //市审核
      shengspflag: this.$route.query.shengspflag, //市审核 //1蓝2绿3灰
      active2: this.$route.query.active2, //日报周报选中状态
      priceDate:this.$route.query.priceDate,
      lateReportTime:this.$route.query.lateReportTime,
      dis: true, //审核状态的事项不可提交
      stateId:this.$route.query.stateId,
      cxState: true,
      showDetial: false, //展示商品说明
      shopIndex: '',
      shopName: '', //商品名称
      bqPrice: '', //本期价格
      bqPriceSave:'',
      contentSave:"",
      isGoods:"", //无此品种  1无，0有
      brand: '', //品牌
      content: '', //说明
      comments: '',//备注
      ifShow:'',//为0的时候不显示 品牌文本框,1时显示
      originBrand:'',//品牌产地
      originBrandShow:false,
      itemNumbersShow:false,
      itemNumbers:'',//数量
      shopIndex1: '',
      ids: [], //数据
      showLog: false, //展示日志列表
      logList: [], //日志列表
      showLogDetial: false, //展示日志详情
      loginStatus: true,
      levelNum:this.$route.query.levelNum,//用户等级

      dlrflag:this.$route.query.dlrflag,//待录入
      dsbflag:this.$route.query.dsbflag,//待上报
      ythflag:this.$route.query.ythflag,//已退回

      taskName:'',//任务名称
      stationName:'',//监测点
      stationList:[],
      shopIdList:[],//taskId
      StationCode:'',
      lastStation:'', //判断是否是最后一个监测点
      btnFlag: false,
      dropdownInput:'',
      inputTable:[],
      showDrop:false,
      taskConfig: [],
      isGoodsName: '',
      color: ['#f2fbfe', '#e0f7ff'],
    }
  },
  created() {
    this.init()
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    init() {
      // 初始化暂未定
      loading(true)
      this.onLoad()
      this.checkLogin();
      if (this.loginStatus) {
        this.getStationList('init')
      }
    },
    // 获取监测点列表
    getStationList(val) {
      getStationList({
        taskCode: this.taskCode,
        exeno: this.exeno,
      }).then(res => {
        res.forEach(i=> {
          i.value = i.codeValue
          i.text = i.codeName
          i.stateName = getName(i.stateId)
        })
        this.stationList = res
        this.inputTable = res
        if(val == 'init') {
          this.dataGridNew()
        }
      })
    },
    // 获取采集详情
    dataGridNew() {
      if (
        (this.dsbflag != 2 || this.ythflag!=2 ) && this.shispflag == 3
      ) {
        this.dis = false//3是灰色 代表还未审核 //1蓝2绿3灰
      } else {
        this.dis = true
      }
      if(this.stateId == 21) {
        this.cxState = false
      }else {
        this.cxState = true
      }
      if (this.active2 == 1) {
        this.dis = true
        this.cxState = true
      }
      this.StationCode = this.stationList.map(item => item.value).join(',')
      var last = this.stationList.slice(-1)
      this.lastStation = last[0].value
      dataGridNew({
        taskCode: this.taskCode,
        ExeNo: this.exeno,
        StationCode: this.StationCode,
      }).then(result => {
        let hbNum //环比
        const res = result.dataList
        this.taskConfig = result.taskConfig
        for (let i = 0; i < res.length; i++) {
          this.shopIdList.push(res[i].shopId);

          this.taskName=res[i].taskName;
          this.stationName=res[i].stationname;

          let ringPrice = res[i].ringPrice //上期 ringPrice
          let thisPrice = res[i].ThisPrice //本期 ThisPrice
          res[i].isGoods = res[i].isGoods == 1 ? 1 : 0
          if(res[i].ringIsGoods !== undefined) {
            res[i].isGoods = res[i].ringIsGoods
          }
          if (res[i].ThisPrice == -1 || res[i].ThisPrice == '-') {
            res[i].ThisPrice = '';
            res[i].hbNum = '-';
            continue;
          }
          if (!Number(ringPrice) || ringPrice == 0 || !Number(thisPrice)) {
            res[i].hbNum = '-'
            continue
          }
          ringPrice = parseFloat(ringPrice)
          thisPrice = parseFloat(thisPrice)
          hbNum = (thisPrice - ringPrice) / ringPrice*100
          if (hbNum == Infinity || isNaN(hbNum)) {
            res[i].hbNum = '-'
          } else {
            if (hbNum > 0) {
              res[i].styleColor = 'red'
            } else if (hbNum < 0) {
              res[i].styleColor = 'green'
            } else {
              res[i].styleColor = 'black'
            }
            if (
              hbNum.toString().indexOf('.') != -1 &&
              hbNum.toString().split('.')[1].length > 2
            ) {
              hbNum = hbNum.toFixed(2)
            }
            res[i].hbNum = hbNum
            res[i].ifShow = this.isUp(res[i].stateId)
          }
        }
        // this.list = res;
        this.handTbaleDataOne(res, 'pzCode')
        this.shopIdList=Array.from(new Set(this.shopIdList));//去重
        loading(false)
      })
    },
    // 逻辑-列表背景色
    handTbaleDataOne(tableList, val) {
      /**
       * tableList:列表数据集
       * val:根据什么字段相同的数据 一个背景色
       */
      let list = JSON.parse(JSON.stringify(tableList));
      let rowNum = 0;
      let lcol = 0;
      let rowBool = false;
      for (let i = 0; i < list.length; i++) {
        if (lcol > this.color.length - 1) {
          lcol = 0;
        }
        if (rowBool) {
          if (
            list[i][val] !== null &&
            i !== 0 &&
            list[i][val] === list[i - 1][val]
          ) {
            rowBool = true;
            list[i].rowNumber = list[rowNum].rowNumber;
          } else if (
            i === 0 ||
            (list[i][val] !== null && list[i][val] !== list[i - 1][val])
          ) {
            rowBool = false;
            list[i].rowNumber = lcol;
            lcol += 1;
          }
        } else {
          if (
            list[i][val] !== null &&
            i !== 0 &&
            list[i][val] === list[i - 1][val]
          ) {
            rowNum = i - 1;
            rowBool = true;
            list[i].rowNumber = list[rowNum].rowNumber;
          } else if (
            i === 0 ||
            (list[i][val] !== null && list[i][val] !== list[i - 1][val])
          ) {
            rowBool = false;
            list[i].rowNumber = lcol;
            lcol += 1;
          }
        }
      }
      this.list = list;
      lcol = 0;
    },
    dropClick(code, name) {
        this.dropdownInput = name;
        this.showDrop = !this.showDrop;
        this.jump(code)
    },
    hideTabs() {//隐藏展示滚动tabs
        this.fuzzyQuery(this.dropdownInput);
        this.showDrop = true;
        loading(false)
    },
    showTabs() {//展示滚动tabs
        this.showDrop = false;
    },
    fuzzyQuery(keyWord) {//搜索筛选方法
        // if(keyWord.length==0) {
        //     return
        // }
        const arr = [];
        for(let i = 0;i < this.stationList.length;i++) {
            if(this.stationList[i].text.indexOf(keyWord) >= 0) {
                arr.push(this.stationList[i]);
            }
        }
        // console.log(this.inputTable);
        this.inputTable = arr;
    },
    // 跳转至监测点指定位置
   jump(value){
      this.$nextTick(() => {
        setTimeout(() => {
            document.getElementById(value).scrollIntoView({ behavior: "smooth",block: "center", });
        })
      })
    },
  //置顶图标
    backTop() {
      const that = this
      const timer = setInterval(() => {
          const ispeed = Math.floor(-that.scrollTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
          if (that.scrollTop === 0) {
              clearInterval(timer)
          }
      }, 16)
    },
    // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
    scrollToTop() {
        const that = this
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        that.scrollTop = scrollTop
        that.btnFlag = that.scrollTop > 130;
        // that.isBarNav = that.scrollTop > 10;
    },


    isUp(ext) {//未填报0,未提交1,县市区已退回89,市级已退回90,省级已退回99('0','1','89','90','99')案件状态
    ext = ext + ""

        return ['0', '1', '89', '90','99'].indexOf(ext) !== -1;
    },
    //保存价格采集
    saveRow(type,editType) {
      loading(true)
      saveRow({
        taskID: this.taskID,
        TempCode: this.code,
        ExeNo: this.exeno,
        priceDate:this.priceDate,
        StationCode: this.StationCode,
        // shopTaskId: this.shopId,
        shopTaskId:this.shopIdList.toString(),
        json: JSON.stringify(this.list),
        taskCode:this.taskCode,
        editType:editType,
      }).then(res => {
        if (res.success) {
          if (type == 1) {
            this.upOK();
            return;
          }
          this.getStationList()
          loading(false)
          Toast.success(res.info)
        } else {
          Toast({
            message: res.info.replace(/<\/br>/g, '\n'),
            position: 'center',
            overlay:true,
            });
          Toast.setDefaultOptions({ duration: 3600 });
          setTimeout(() => {
            if(res.ids==undefined) return;
            if (res.ids != '') {
              this.ids = JSON.parse(JSON.stringify(res.ids.split(',')))
              let listIndex
              for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].VarietyCode == this.ids[0]) {
                  listIndex = i
                }
                for (let j = 0; j < this.ids.length; j++) {
                  if (this.list[i].VarietyCode == this.ids[j]) {
                    this.list[i].VarietyCodeNew = this.ids[j]
                    continue
                  }
                }
              }
              this.clickStoreName(this.list[listIndex], listIndex)
            }
          }, 3600)
        }
      })
    },
    //上报
    upOK() {
      upOkCountry({
        shopTaskIds: this.shopIdList.toString(),
        exeno: this.exeno,
        taskCode:this.taskCode,
        stationCode:this.StationCode,
      }).then(res => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message)
          this.dis = true
          this.cxState = false
          setTimeout(() => {
            this.onClickLeft()
          }, 500)
        } else {
          this.ids = res.ids
          // Toast.fail(res.info.replace(/<\/br>/g, '\n'))
          Toast.fail(res.message)
        }
      })
    },
    chexiao() {
      //撤销修改
      this.$dialog
        .confirm({
          message: "是否确认撤回提交?",
        })
        .then(() => {
          this.countyRedo();
        })
        .catch(() => {});
    },
    countyRedo() {
      loading(true)
      countyRedo({
        ID: this.shopIdList.toString(),
        exeno: this.exeno,
        taskCode: this.taskCode,
        stationCode: this.StationCode,
        taskId: this.taskID,
        backInfo: ''
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message);
          this.cxState = true
          this.dis = false
          this.getStationList()
        } else {
          Toast.fail(res.message.replace(/<\/br>/g, "\n"));
        }
      });
    },
    onClickLeft() {
        this.$router.push({
          path: "/xmtbcaiji",
          query: {
            active: this.active,
            active2: this.active2,
            startTime: this.$route.query.startTime,
            endTime: this.$route.query.endTime
          }
        })
    //   }
    },
    onLoad() {
      //初始化table
      loading(true)
      // this.dataGridNew()
      setTimeout(() => {
        // 加载状态结束
        this.loading = false
        this.loading1 = false
        // 数据全部加载完成
        this.finished = true
      }, 1000)
    },
    //环比实时变化
    changePrice(i) {
      let hbNum
      let ringPrice = this.list[i].ringPrice //上期 ringPrice
      let thisPrice = this.list[i].ThisPrice //本期 ThisPrice

      if (!Number(thisPrice)) {
        this.list[i].hbNum = '-'
        return
      }
      if(thisPrice.split(".").length-1 >1){
        Toast("本期价格输入格式不正确请重新输入!")
        return;
      }
        thisPrice = parseFloat(thisPrice).toFixed(this.list[i].report_digits)
        this.list[i].ThisPrice = thisPrice
      if (!Number(ringPrice) || ringPrice == 0) {
        this.list[i].hbNum = '-'
        return
      }
      ringPrice = parseFloat(ringPrice)
      thisPrice = parseFloat(thisPrice)
      hbNum = ((thisPrice - ringPrice) / ringPrice) * 100
      if (hbNum == Infinity || isNaN(hbNum)) {
        this.list[i].hbNum = '-'
      } else {
        if (
            hbNum.toString().indexOf('.') != -1 &&
            hbNum.toString().split('.')[1].length > 2
        ) {
            hbNum = hbNum.toFixed(2)
        }
        if (parseInt(hbNum) > 0) {
          this.list[i].styleColor = 'red'
          this.list[i].HB = "<span style='color:red'>涨" + hbNum + '<span>'
        } else if (parseInt(hbNum) < 0) {
          this.list[i].styleColor = 'green'
          this.list[i].HB = "<span style='color:green'>跌" + hbNum + '<span>'
        } else {
          this.list[i].styleColor = 'black'
        }
        this.list[i].hbNum = hbNum
      }
    },
    daoru() {
      loading(true)
      //导入上期
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].ringPrice == '-' || this.list[i].ringPrice == '' || this.list[i].isGoods == 1) {
          continue
        } else {
          this.list[i].ThisPrice = this.list[i].ringPrice
          if (this.list[i].ringPrice != 0) {
            this.list[i].styleColor = 'black'
            this.list[i].hbNum = 0
          }
        }
      }
      setTimeout(()=> {
        loading(false)
      },1000)
    },
    //判断是否复核判断条件
    ifCheckSaveRow(){
      try {
        validRange(this.list);
      } catch (error) {
        return false;
      }
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (
          this.ifNullOrEmpty(item.Memo,0) &&
          ((item.ThisPrice == 0 && item.ThisPrice != "")
          ||  (item.hbzks !== null&& item.hbNum >= item.hbzks && item.hbNum > 0)
          ||  (item.hbjks !== null && Math.abs(item.hbNum) >= item.hbjks && item.hbNum < 0)
          )
        ) {
          Toast("数据" + item.VarietyName + "请填写波动原因说明!");
          this.clickStoreName(this.list[i], i);
          return false;
        }
      }
      return true;
    },
    ifCheckUpOk() {
      try {
        validRange(this.list);
      } catch (error) {
        return false;
      }
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
         if (this.ifNullOrEmpty(item.Memo,1)) {
            Toast("数据"+item.VarietyName+"说明的字数不能太少，至少2个文字!")
            this.clickStoreName(this.list[i], i);
            return false;
         }
        if (this.ifNullOrEmpty(item.Memo,0)  && ((item.ThisPrice == 0 && item.ThisPrice != "") || (item.ThisPrice == '') ||(item.hbzks !== null&& item.hbNum >= item.hbzks && item.hbNum > 0)|| (item.hbjks !== null && Math.abs(item.hbNum) >= item.hbjks && item.hbNum < 0) ) ) {
          Toast("数据" + item.VarietyName + "请填写波动原因说明!");
          this.clickStoreName(this.list[i], i);
          return false;
        }
        let bq = item.ThisPrice
        let sq = item.ringPrice
        let multiPrice = item.sameNumPrice
        let multiCount = item.sameNum
        let multiCountTwo = item.sameNum
        if(Number(bq) > 0 && Number(sq) > 0 && multiPrice && item.dqbb) {
          if (parseFloat(bq) === parseFloat(multiPrice)) {
            multiCountTwo = multiCountTwo + 1
          }
          if(multiCountTwo >= item.dqbb && !item.Memo && parseFloat(bq) == parseFloat(multiPrice)){
            Toast(`${item.VarietyName}价格${parseInt(multiCountTwo)}期不变, 请填写说明!`);
            this.clickStoreName(this.list[i], i);
            return false;
          }
        }
      }
      return true;
    },
    ifNullOrEmpty(obj,type) {
      var regu = "^[ ]+$";
      var re = new RegExp(regu);
      if (type==0 &&  (typeof obj == "undefined" || obj == null || obj == "" || re.test(obj))
      ) {
        return true;
      }else if( !(typeof obj == "undefined" || obj == null || obj == "" || re.test(obj)) && obj.length<2 && type==1 ){
        return true;
      } else {
        return false;
      }
    },
    save() {
      //保存
      if(!this.ifCheckSaveRow()) return;
      // this.saveRow(0,"2")
      if(this.ythflag==1){//退回并修改 4  //1蓝2绿3灰
        this.saveRow(0,"4")
      }else{
         this.saveRow(0,"2")
      }
    },
    tongguo() {
      if (!this.ifCheckUpOk()) return;
      //审核通过
      this.$dialog
        .confirm({
          message: "是否确认"+"提交通过"+"?",
        })
        .then(() => {
          this.saveRow(1,"5");
        })
        .catch(() => {});
    },
    // 点击商品名
    clickStoreName(item, index) {
      this.shopIndex = index;
      this.detailData = item
      this.detailData.shopIndex1 = index + 1
      let reason = rulesInfoDeal(item)
      if(reason.isWarn && reason.warnMsg) {
        this.detailData.placeholder = reason.warnMsg
      }else {
        this.detailData.placeholder = ''
      }
      this.$refs.detailRef.initData(this.detailData)
    },
    // 关闭弹框
    closeBasic() {
      this.showDetial = false
    },
    //保存弹框信息
    saveBasic(row) {
      if (row.bqPrice > 99999999) {
        row.bqPrice = 99999999;
      } else if (row.bqPrice < 0) {
        row.bqPrice = 0;
      }
      this.list[this.shopIndex].ThisPrice = row.bqPrice; //本期价格
      this.list[this.shopIndex].Memo = row.content;//说明
      this.list[this.shopIndex].comments = row.comments; //备注
      this.list[this.shopIndex].isGoods = row.isGoods?1:0; //无此品种
      this.$refs.listRef.changePrice('', this.shopIndex)
    },
    // 查看日志按钮
    chaKanRiZhi() {
      this.$refs.logRef.show()
      loading(true)
      this.getDateRecord();
    },
    //查看日志
    getDateRecord() {
      getDateRecord({
          taskId:this.taskID,
          exeNo:this.exeno,
          stationCode:this.StationCode,
      }).then(res => {
        this.logList = res
        loading(false)
      })
    },
    //监测登陆状态 houcc 2021.07.24
    checkLogin() {
        checkLogin({}).then(res => {
            if (!res.success) {
                // nativeJSBridge.logout();
                this.$router.push({ path: '/loginOld'});
            }
            this.loginStatus = res.success;
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#caijixiangqingLessNew {
  background: #f0f2f1;
  height: 100%;
  /deep/.van-nav-bar__text:active {
    background-color: transparent;
  }
  //置顶图标
    .toTopIcon {
        z-index: 100;
        position: fixed;
        bottom: 6%;
        right: 6%;

        .van-icon {
            font-size: px2rem(100);
            color: #ffa800;
        }
    }
  .xinxi {
    padding-left: 0.363rem;
    padding-right: 0.1rem;
    padding-top: 0.3rem;
    padding-bottom: 0.1rem;
    width: calc(100vw - 0.463rem);
    min-height: 2.3rem;
    background-color: #ffffff;
    font-size: px2rem(36);
    color: #4494f3;
    vertical-align: middle;
    margin-bottom: 0.2rem;
  }
  .blue-box {
    display: inline-block;
    width: 0.06rem;
    height: 0.26rem;
    margin-right: 0.09rem;
    background-color: #4494f3;
  }
  .boxTitle {
    height: 1rem;
    line-height: 1rem;
    background-color: #4494f3;
    color: #ffffff;
    font-size: px2rem(36);
  }
  .twoTitle{
    color: #666666;
  }
  .table {
    height: calc(100% - 5.7158rem);
    .input {
      display: inline-block;
      vertical-align: middle;
      //   height: 0.9rem;
      //   line-height: 0.9rem;
      width: 1.3rem;
      background-color: #fff;
      border: px2rem(1) solid #4494f3;
      input {
        // margin: 0;
        // border: 0;
        // height: 0.7rem;
        // vertical-align: middle;
        // width: 1.3rem;
        // outline: none;
        margin: 0;
        border: 0;
        height: 0.8rem;
        vertical-align: middle;
        width: 1.3rem;
        outline: none;
        text-align: right;
      }
    }
    .even {
      display: flex;
      font-size: px2rem(36);
      background-color: #f2fbfe;
      color: #3e3e3e;
      /deep/.van-row {
        width: 100vw;
        height: 50px;
      }
    }
    .odd {
      display: flex;
      font-size: px2rem(36);
      background-color: #e0f7ff;
      color: #3e3e3e;
      /deep/.van-row {
        width: 100vw;
        height: 50px;
      }
    }
    .contentLimit {//表格内容商品列限制三行展示
      word-break:break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display:-webkit-box;
      -webkit-line-clamp:3;
      -webkit-box-orient: vertical;
    }
  }
.bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    background-color: #fff;
    .btn1 {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      font-size: px2rem(45);
      color: #2c7fe2;
      font-weight: bold;
      font-family: "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
      width: 2rem;
      // border-right: 1px solid #ababab;
    }
    v-button.btn1::after {
        content: '';
        width: 0.02rem;
        height: 0.6rem;
        background: #ababab;
        position: absolute;
        right: 0;
    }
    v-button.btn2::after {
        content: '';
        width: 0rem;
        height: 0rem;
        // background: #ababab;
        // position: absolute;
        // right: 0;
    }

  }
  //提交上报的事项 底部按钮变灰
  .bianhui {
    pointer-events: none;
    filter: grayscale(1);
  }

  .btn {
    display: inline-block;
    width: 2rem;
    height: 1rem;
    line-height: 1rem;
    border-radius: 1rem;
    background-color: #3486e8;
    color: #ffffff;
    font-size: px2rem(45);
    text-align: center;
    vertical-align: middle;
  }
  /deep/.van-field--disabled .van-field__label {
    color: #000;
  }
  /deep/.van-field__control:disabled {
    color: #000;
    font-weight: bold;
    -webkit-text-fill-color: #000;
  }
  /deep/ .van-field__label {
    color: #000;
  }
  /deep/.van-field__control {
    color: #000;
    font-weight: bold;
    -webkit-text-fill-color: #000;
  }
  /deep/.van-cell {
    padding: 5px 16px;
    line-height: 0.9rem !important;
  }
  /deep/.van-field__label {
    width: 1.2rem !important;
  }
  /deep/ .long-label .van-field__label {
    width: 1.5rem !important;
  }
  /deep/ .long-txt .van-field__label {
    width: 1.8rem !important;
    line-height: 0.5rem !important;
    margin-top: 0.2rem;
    margin-left: -0.23rem;
  }
  .goodIs {
    width: 1.9rem;
    font-size: 0.37037rem;
    line-height: 1.2rem;
    height: 1.2rem;
  }
  .g_disabled {
    /deep/.van-field__control:disabled {
      color: #c8c9cc!important;
      -webkit-text-fill-color: #c8c9cc!important;
    }
  }
  .logTable {
    height: calc(100% - 1rem);
    .no-con {
      color:#3e3e3e;
      font-size:px2rem(36);
      text-align:center;
      margin: 0 auto;
      padding: 2rem 0;
    }
  }
  .even {
    display: flex;
    font-size: px2rem(36);
    background-color: #f2fbfe;
    color: #3e3e3e;
    /deep/.van-row {
      width: 100vw;
      height: 50px;
    }
  }
  .odd {
    display: flex;
    font-size: px2rem(36);
    background-color: #e0f7ff;
    color: #3e3e3e;
    /deep/.van-row {
      width: 100vw;
      height: 50px;
    }
  }
  .logTitle {
    width: 100%;
    padding: px2rem(10) 0;
    color: #000;
    font-size: px2rem(60);
    font-weight: bold;
    text-align: center;
  }
  .logText {
    width: 100%;
    padding: px2rem(10) 0;
    color: #000;
    font-size: px2rem(40);
    font-weight: bold;
    text-align: left;
  }
  .logBox {
    margin: px2rem(20) px2rem(15);
    padding: 0.1rem 0;
    padding-bottom: 0.35rem;
    background-color: #fff;
    font-size: px2rem(36);
    /deep/.van-row {
      margin-top: 0.15rem;
    }
    // border-radius: 25px;
  }
  .twoLine {
    color: #020202;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height:0.48rem;
  }
  /deep/.van-search{
    height: 0.7rem;
  }
  .wrapper {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        height: 100vh;
        position: fixed;
        // top: 3.63rem;
        left: 0;
        z-index: 1000;
        background-color: rgba(0,0,0,.7);
    }
    .block {
        position: relative;
        width: 100%;
        max-height: 50vh;
        background-color: #fff;
        color: #000;
        overflow-x: hidden;
        overflow-y:scroll;
        -webkit-overflow-scrolling:touch;
    }
}
</style>